/**
 * Project : workspace
 * File    : SelectProductSubCategoryCard.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.inventory.sub_category.component

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ElevatedCard
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.RadioButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.parmartechnologies.core.feature.productSubCategory.model.ProductSubCategory
import locale.localization
import theme.ThemeColor

@OptIn(ExperimentalMaterial3Api::class)
@Composable
/**
 * Executes the select product sub category card operation.
 *
 * @receiver TODO
 * @param subCategory The sub category.
 * @return Unit – no return value.
 */
fun SelectProductSubCategoryCard(
    subCategory: ProductSubCategory?,
    selectedSubCategory: ProductSubCategory?,
    onClick: (subCategory: ProductSubCategory?) -> Unit
) {
    val isSelected = selectedSubCategory?._id == subCategory?._id
    ElevatedCard(
        modifier = Modifier.height(60.dp).fillMaxWidth().padding(8.dp),
        colors = CardDefaults.cardColors(
            containerColor = ThemeColor.shared().cardBackground,
            contentColor = Color.Black
        ),
        onClick = {
            onClick(subCategory)
        }
    ) {
        if (subCategory?._id?.isNotEmpty() == true) {
            Row(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(start = 15.dp, end = 15.dp),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                RadioButton(isSelected, { onClick(subCategory) })
                Text(
                    modifier = Modifier.weight(1f).padding(end = 8.dp),
                    text = subCategory.Name, fontSize = 14.sp, textAlign = TextAlign.Start
                )
            }
        } else {
            Row(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(start = 15.dp, end = 15.dp),
                verticalAlignment = Alignment.CenterVertically,
            ) { //
                Text(
                    modifier = Modifier.weight(1f).padding(end = 8.dp),
                    text = localization().subCategory.subCategorySelect,
                    fontSize = 14.sp,
                    textAlign = TextAlign.Center
                )
            }
        }
    }
}